<template>
  <div
    :class="`card border-start border-start-${borderColor} border-start-width-2 h-100`"
  >
    <div
      class="card-body d-flex flex-column justify-content-between text-center"
    >
      <div>
        <span v-if="course.type == 1" class="badge-course-ethos" />
        <h6 class="text-primary mt-2">{{ course.name }}</h6>
        <p v-if="showStatus">
          <span v-html="statusTranslate(course.status, 'course')" />
        </p>
        <p>{{ course.description }}</p>
      </div>
      <div v-if="showProgress" class="progress" style="height: 0.875rem">
        <div
          class="progress-bar bg-info"
          :style="`width: ${course.percentageCompleted}%`"
        >
          <span>{{ course.percentageCompleted }}%</span>
        </div>
      </div>
    </div>
    <div class="card-footer px-2 text-center">
      <slot />
    </div>
  </div>
</template>

<script>
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'CardCourse',

  props: {
    course: {
      type: Object,
      required: true,
    },
    borderColor: {
      type: String,
      required: true,
    },
    showStatus: {
      type: Boolean,
      required: true,
    },
    showProgress: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      statusTranslate,
    }
  },
}
</script>
